import { Link } from "react-router-dom";
import styles from "../styles/footer.module.css";

function Footer() {
    return (
        <footer className={styles.footer} >
            {/* Contenedor del texto principal */}
            <div className={styles.textContainer}>
                <h2 className={styles.titulo}>
                    LISTO PARA <span className={styles.resaltado}>PONERTE</span> A PUNTO?
                </h2>
                <p className={styles.email}>
                    <span className={styles.iconoCorreo}>✉</span> info@globalsportisalut.com
                </p>
                {/* Contenedor de redes sociales */}
                <div className={styles.socialContainer}>
                    <div className={styles.telefono}>
                        <a >Telf: 699 12 48 85</a>

                    </div>
                    <a href="https://www.linkedin.com/company/globalfisioter%C3%A0pia/" className={styles.socialIcon} target="_blank" rel="noopener noreferrer">
                        <img src="/assets/linkedin_ICON.png" alt="LinkedIn" />
                    </a>
                    <a href="https://www.facebook.com/globalfisioterapia2003/" className={styles.socialIcon} target="_blank" rel="noopener noreferrer">
                        <img src="/assets/facebook_ICON.png" alt="Facebook" />
                    </a>
                 
                    <a href="https://www.instagram.com/globalfisioterapia/" className={styles.socialIcon} target="_blank" rel="noopener noreferrer">
                        <img src="/assets/instagram_ICON.png" alt="Instagram" />
                    </a>
                </div>
            </div>
            <div className={styles.imagenContainerFooter}>
                <div
                    onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                    className={styles.imagenLetrasFooterWrapper} // Puedes añadir un wrapper si quieres estilos específicos para el clic
                    style={{ cursor: 'pointer' }} // Para indicar que es clicable
                >
                    <img src="assets/letrasGLOBLAL.png" alt="Letras GLOBAL" className={styles.imagenLetrasFooter} />
                </div>
            </div>
        
            {/* Contenedor de políticas */}
            <div className={styles.politicas}>
                <p className={styles.copyright}>
                    © Copyright 2025 Fisioterapia Global sport i salut | Todos los derechos reservados |
                    <Link to="/aviso-legal"> Aviso legal</Link> |
                    <Link to="/privacidad"> Política de privacidad</Link> |
                    <Link to="/cookies"> Política de cookies</Link>
                </p>
            </div>
           

            
          
               
        </footer>
    );
}

export default Footer;
